export class ConfigHelper {

    public static Version: string = '4.9.7';

    public static Projeto: string = 'Stellantis';

    public static Distribuidor: string = 'Stellantis';

    public static Url: string = 'https://api.entregaimpecavel.app/api/';
    
    public static UrlIntergracao: string = 'https://api.entregaimpecavel.app/api/';

    public static UrlStorage: string = 'https://integracao.camptecnologia.com.br/';

    public static UrlCheckList: string = 'https://checklist.entregaimpecavel.app/';

    public static UrlPesquisaV1: string = 'https://api-pesquisa.entregaimpecavel.app/v1/stellantis/';

    public static ApiCheckListV1: string = 'checklist/acampa/v1/';

    public static ApiAnexosV1: string = 'checklist_anexos/acampa/v1/';

    public static Token: string = 'a59e7487cb56a218e6113396e64261981c647603';

    public static TokenDms: string = 'f08Ae54b97c066d0ecSD256f97c0608e54b9ea26d0e54a7RRea2e135';

    public static TokenStorage: string = 'd76e45028a10cfba523b17118f99e2e3';

    public static TokenChecklist: string = '088eceae0ebef44e9b39b83bf1df285f2fd27c9550fc9b319b8df8b3bd5ef25234780156$1$0IM3sqIV$4kfgzIMhpmIXOAgdwDB5W0';

    public static TokenPesquisa: string = 'd76e45028a10cfba523b17118f99e2e3';

    //acampa31
    public static storageKeys = {
        codConcessionaria: 'stellantis_08_22.codConcessionaria',
        cnpj: 'stellantis_08_22.cnpj',
        cpf: 'stellantis_08_22.cpf',
        atualizaautomaticamente: 'stellantis_08_22.atualizaautomaticamente',
        precoosagregados: 'stellantis_08_22.precoosagregados',
        concessionaria: 'stellantis_08_22.concessionaria',
        cardapios1: 'stellantis_08_22.cardapios1',
        cardapios2: 'stellantis_08_22.cardapios2',
        marcamodelo: 'stellantis_08_22.marcamodelo',
        checklistEntrada: 'stellantis_08_22.checklistEntrada',
        checklistMecanico: 'stellantis_08_22.checklistMecanico',
        checklistSaida: 'stellantis_08_22.checklistSaida',
        checklistOrcamento: 'stellantis_08_22.checklistOrcamento',
        checklistOficina: 'stellantis_08_22.checklistOficina',
        checklistInspecao: 'stellantis_08_22.checklistInspecao',
        checklistExtra: 'stellantis_08_22.checklistExtra',
        cameraAberta: 'stellantis_08_22.cameraAberta',
        ultimaDataLimpaCache: 'stellantis_08_22.ultimaDataLimpaCache',
        tiposAnexos: 'stellantis_08_22.tiposAnexos'
    }

    public static storageKeysSessions = {
        concessionariasAcesso: 'stellantis_08_22.concessionariasAcesso',
        concessionariasStorage: 'stellantis_08_22.concessionariasStorage',
        imagensCardapio: 'stellantis_08_22.imagensCardapio'
    }
}


// WEBPACK FOOTER //
// ./src/app/helpers/configHelper.ts